(() => {
  if (window.juniorBrowseReady) return;
  window.juniorBrowseReady = true;
  let controller;
  let pendingURL;
  const cache = new Map();
  const cacheKey = href => {
    const url = new URL(href, location.href);
    url.hash = '';
    url.searchParams.sort();
    return url.href;
  };
  const remember = (href, html) => {
    const key = cacheKey(href);
    cache.delete(key);
    cache.set(key, { html, expires: Date.now() + 30000 });
    if (cache.size > 20) cache.delete(cache.keys().next().value);
  };
  const root = () => document.querySelector('[data-junior-filters]');
  const isShowcase = () => root()?.dataset.view === 'growplay-junior-collection';
  const pageKey = href => { const url = new URL(href, location.href); return url.pathname + url.search; };
  let renderedKey = pageKey(location.href);
  let restoring = false;
  let restoreFrame;
  const savePlace = () => {
    if (!isShowcase() || restoring || renderedKey !== pageKey(location.href)) return;
    history.replaceState({ ...history.state, juniorPlace: {
      key: renderedKey,
      top: window.scrollY,
      chips: root().querySelector('.junior-filters__chips')?.scrollLeft || 0
    } }, '', location.href);
  };
  const restorePlace = place => {
    if (!isShowcase() || place?.key !== pageKey(location.href)) return;
    restoring = true;
    cancelAnimationFrame(restoreFrame);
    restoreFrame = requestAnimationFrame(() => {
      restoreFrame = requestAnimationFrame(() => {
        root().querySelector('.junior-filters__chips').scrollLeft = place.chips || 0;
        window.scrollTo({ top: place.top || 0, behavior: 'instant' });
        restoring = false;
      });
    });
  };
  if (isShowcase()) history.scrollRestoration = 'manual';
  const live = document.createElement('div');
  live.id = 'junior-results-status';
  live.className = 'junior-filters__sr';
  live.setAttribute('role', 'status');
  live.setAttribute('aria-live', 'polite');
  live.setAttribute('aria-atomic', 'true');
  document.body.append(live);

  const syncSizes = (href = location.href) => {
    const controls = root();
    if (controls?.dataset.view !== 'growplay-junior-collection') return;
    const currentURL = new URL(href, location.href);
    const selected = currentURL.searchParams.get('filter.p.m.custom.play_module_count');
    const activityKey = 'filter.p.m.custom.included_modules';
    const activities = currentURL.searchParams.getAll(activityKey);
    const heading = document.querySelector('[data-junior-showcase-heading]');
    if (heading) heading.textContent = ['2', '3', '4', '5'].includes(selected)
      ? heading.dataset.bayHeading.replace('[count]', selected)
      : heading.dataset.allHeading;
    document.querySelectorAll('[data-junior-other-size]').forEach(link => {
      link.hidden = link.dataset.juniorOtherSize === selected;
    });
    controls.querySelectorAll('.junior-filters__sizes [data-focus-key]').forEach(link => {
      const active = link.dataset.focusKey === `size-${selected || 'all'}`;
      if (active) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
      const target = new URL(link.href);
      target.searchParams.delete(activityKey);
      activities.forEach(value => target.searchParams.append(activityKey, value));
      link.href = target.href;
    });
    controls.querySelectorAll('[data-module-id]').forEach(button => {
      const active = activities.some(value => value.split('/').pop() === button.dataset.moduleId);
      button.classList.toggle('is-selected', active);
      button.setAttribute('aria-pressed', String(active));
      if (active) {
        const target = new URL(currentURL);
        target.searchParams.delete(activityKey);
        activities.filter(value => value.split('/').pop() !== button.dataset.moduleId).forEach(value => target.searchParams.append(activityKey, value));
        button.dataset.juniorFilterUrl = target.href;
        button.disabled = false;
        button.removeAttribute('title');
        button.removeAttribute('aria-disabled');
        delete button.dataset.unavailableMessage;
      }
    });
    const hasFilters = [...currentURL.searchParams.keys()].some(key => key.startsWith('filter.'));
    const state = controls.querySelector('[data-junior-filter-state]');
    if (state) state.hidden = !hasFilters;
    const selectedModules = controls.querySelector('[data-junior-selected-modules]');
    if (selectedModules) {
      const names = activities.map(value => [...controls.querySelectorAll('[data-module-id]')]
        .find(button => button.dataset.moduleId === value.split('/').pop())?.dataset.moduleName).filter(Boolean);
      selectedModules.textContent = names.join(' + ');
      selectedModules.hidden = !names.length;
    }
    const priceRange = controls.querySelector('[data-junior-price-range]');
    if (priceRange) priceRange.hidden = hasFilters;
    const clear = controls.querySelector('[data-focus-key="clear"]');
    if (clear) {
      const target = new URL(currentURL);
      [...target.searchParams.keys()].filter(key => key.startsWith('filter.')).forEach(key => target.searchParams.delete(key));
      target.searchParams.delete('page');
      target.hash = 'junior-filters';
      clear.href = target.href;
    }
    const reset = document.querySelector('[data-junior-reset-results]');
    if (reset) reset.hidden = !hasFilters;
    const form = controls.querySelector('[data-junior-filter-form]');
    if (form) {
      form.querySelectorAll(`[name="${activityKey}"]`).forEach(input => input.remove());
      activities.forEach(value => {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = activityKey; input.value = value;
        form.append(input);
      });
    }
    form?.querySelector('[data-junior-size-state]')?.remove();
    if (selected && form && !form.querySelector('[name="filter.p.m.custom.play_module_count"]')) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'filter.p.m.custom.play_module_count';
      input.value = selected;
      input.dataset.juniorSizeState = '';
      form.append(input);
    }
  };
  syncSizes();
  if (isShowcase()) remember(location.href, root().closest('.shopify-section').outerHTML);
  document.addEventListener('shopify:section:load', () => syncSizes());

  const cleanURL = input => {
    const url = new URL(input, location.href);
    const current = new URL(location.href);
    ['view', 'preview_theme_id', 'oseid'].forEach(key => {
      if (!url.searchParams.has(key) && current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    });
    url.searchParams.set('view', root()?.dataset.view || 'growplay-junior');
    ['page', 'filter.v.price.gte', 'filter.v.price.lte'].forEach(key => url.searchParams.delete(key));
    if (!['price-ascending', 'price-descending'].includes(url.searchParams.get('sort_by'))) url.searchParams.set('sort_by', 'price-ascending');
    url.hash = 'junior-filters';
    return url;
  };

  const update = async (url, focusKey, push = true, place = null) => {
    const controls = root();
    if (!controls) return;
    const section = controls.closest('.shopify-section');
    const showcase = section.querySelector('.jr-showcase');
    const filterTop = controls.getBoundingClientRect().top;
    const scrollLeft = controls.querySelector('.junior-filters__chips').scrollLeft;
    if (push) savePlace();
    controller?.abort();
    const request = new AbortController();
    controller = request;
    section.setAttribute('aria-busy', 'true');
    pendingURL = url;
    // Reflect the user's latest intent immediately; subsequent clicks build on it.
    syncSizes(url.href);
    live.textContent = '';
    if (showcase) {
      const label = showcase.dataset.loadingLabel;
      const count = section.querySelector('[data-junior-result-count]');
      if (label && count) count.textContent = label;
      live.textContent = label || '';
    }
    try {
      const cached = isShowcase() && cache.get(cacheKey(url.href));
      let html = cached && cached.expires > Date.now() ? cached.html : null;
      if (!html) {
        const requestURL = new URL(url);
        // Shopify applies the same native AND filters to this smaller response.
        if (isShowcase()) requestURL.searchParams.set('section_id', controls.dataset.section);
        requestURL.hash = '';
        const response = await fetch(requestURL.href, { signal: request.signal });
        if (!response.ok) throw new Error('Collection response failed');
        html = await response.text();
      }
      const page = new DOMParser().parseFromString(html, 'text/html');
      const next = page.getElementById(section.id);
      if (!next?.querySelector('[data-junior-filters]')) throw new Error('Collection missing');
      if (request.signal.aborted) return;
      if (isShowcase()) remember(url.href, html);
      if (showcase) {
        next.querySelector('.jr-showcase')?.style.setProperty('--jr-showcase-header-offset', showcase.style.getPropertyValue('--jr-showcase-header-offset'));
      }
      section.replaceWith(next);
      const tiles = document.querySelector('.junior-size-selector')?.closest('.shopify-section');
      const nextTiles = tiles && page.getElementById(tiles.id);
      if (nextTiles) tiles.replaceWith(nextTiles);
      if (push) history.pushState({}, '', url.href);
      renderedKey = pageKey(url.href);
      const fresh = root();
      syncSizes(url.href);
      fresh.querySelector('.junior-filters__chips').scrollLeft = scrollLeft;
      const focusTarget = [...fresh.querySelectorAll('[data-focus-key]')].find(el => el.dataset.focusKey === focusKey);
      if (focusKey) (focusTarget || fresh.querySelector('button, select')).focus({ preventScroll:true });
      document.dispatchEvent(new CustomEvent('junior:results-updated'));
      const count = next.querySelector('[data-junior-result-count]')?.textContent.trim();
      live.textContent = count || '';
      if (place) restorePlace(place);
      else {
        if (showcase && push) {
          const filterShift = fresh.getBoundingClientRect().top - filterTop;
          if (Math.abs(filterShift) > 1) window.scrollBy({top:filterShift, behavior:'instant'});
        }
        savePlace();
      }
    } catch (error) {
      if (error.name !== 'AbortError') location.assign(url.href);
    } finally {
      if (controller === request) {
        pendingURL = null;
        root()?.closest('.shopify-section').removeAttribute('aria-busy');
      }
    }
  };

  document.addEventListener('click', event => {
    if (event.target.closest('.jr-oct-card a[href]')) savePlace();
    const control = event.target.closest('[data-junior-filter-url], [data-junior-filter-link]');
    if (!control || !control.closest('[data-junior-filters], .jr-showcase')) return;
    if (control.disabled) return;
    if (control.getAttribute('aria-disabled') === 'true' && !pendingURL) {
      event.preventDefault();
      const feedback = root()?.querySelector('[data-junior-filter-feedback]');
      if (feedback) {
        feedback.textContent = control.dataset.unavailableMessage;
        feedback.hidden = false;
        live.textContent = feedback.textContent;
      }
      return;
    }
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const href = control.dataset.juniorFilterUrl || control.getAttribute('href');
    if (!href) return;
    event.preventDefault();
    let url = cleanURL(href);
    if (control.dataset.moduleId) {
      url = cleanURL(pendingURL || location.href);
      const key = 'filter.p.m.custom.included_modules';
      const values = url.searchParams.getAll(key);
      const selected = values.some(value => value.split('/').pop() === control.dataset.moduleId);
      url.searchParams.delete(key);
      values.filter(value => value.split('/').pop() !== control.dataset.moduleId)
        .forEach(value => url.searchParams.append(key, value));
      if (!selected) {
        const nativeValue = control.dataset.moduleValue;
        if (!nativeValue) return;
        url.searchParams.append(key, nativeValue);
      }
    }
    update(url, control.dataset.focusKey);
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-junior-filter-form]');
    if (!form) return;
    event.preventDefault();
    const url = new URL(location.href);
    [...url.searchParams.keys()].forEach(key => {
      if (key.startsWith('filter.') || key === 'sort_by' || key === 'page') url.searchParams.delete(key);
    });
    for (const [key, value] of new FormData(form, event.submitter)) if (value) url.searchParams.append(key, value);
    if (!event.submitter) url.searchParams.set('sort_by', form.querySelector('[data-junior-sort]').value);
    update(cleanURL(url), event.submitter?.dataset.focusKey || 'sort');
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-junior-sort]')) event.target.form.requestSubmit();
  });
  window.addEventListener('pagehide', savePlace);
  window.addEventListener('pageshow', event => {
    if (!isShowcase()) return;
    const backForward = performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
    if (event.persisted || backForward) restorePlace(history.state?.juniorPlace);
  });
  window.addEventListener('popstate', event => {
    if (!root()) return;
    if (!isShowcase()) { update(cleanURL(location.href), null, false); return; }
    const place = event.state?.juniorPlace;
    if (!pendingURL && renderedKey === pageKey(location.href)) {
      syncSizes();
      restorePlace(place);
    } else {
      update(new URL(location.href), null, false, place);
    }
  });
})();
